<template>
  <div class="tw-p-2 tw-border tw-border-primary tw-border-solid tw-rounded-xl">
    <ValidationProvider
      v-slot="{ errors }"
      :name="name"
      :rules="file.id ? '' : rules"
    >
      <div class="input_wrapper">
        <div class="tw-flex tw-items-center tw-justify-between tw-mb-2">
          <label :for="name">{{ label }}</label>
          <label :for="name">{{ label }}</label>
          <button
            v-if="file.id"
            type="button"
            @click="confirmDelete"
            class="tw-border tw-border-solid tw-border-red-500 tw-rounded-lg tw-text-red-500 tw-px-2"
          >
            <i class="fas fa-trash"></i>
          </button>
        </div>
        <div
          class="tw-flex tw-items-center tw-justify-between tw-mb-2 tw-gap-2"
        >
          <v-file-input
            :disabled="btnLoading"
            :loading="btnLoading"
            @change="uploadImage($event)"
            :name="name"
            label=""
            v-model="file.mainMedia"
            :id="name"
            ref="uploadInput"
          ></v-file-input>
          <button
            v-if="file.preview"
            type="button"
            @click="openPreview = true"
            class="tw-border tw-border-solid tw-rounded-lg tw-text-text tw-px-2"
          >
            <i class="fas fa-eye"></i>
          </button>

          <media-modal
            v-if="openPreview"
            :preview="file.preview"
            type="video"
            @close="openPreview = false"
          />
        </div>
      </div>
      <span v-if="errors[0]" class="error--text d-inline-block">
        {{ errors[0] }}
      </span>
    </ValidationProvider>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      required: true,
    },
    label: {
      required: false,
    },
    rules: {
      required: true,
    },
    data: {
      required: false,
    },
    type: {
      required: false,
      default: "text",
    },
    value: {
      required: true,
    },
    placeholder: {
      required: false,
    },
    modalName: {
      required: false,
    },
  },
  data() {
    return {
      file: {
        mainMedia: null,
        preview: null,
        image: null,

        id: "",
      },
      openPreview: false,
      btnLoading: false,
    };
  },

  methods: {
    uploadImage(event) {
      if (event) {
        this.btnLoading = true;
        const data = new FormData();
        data.append("file", event);
        data.append("attachment_type", "file");
        data.append("model", this.modalName);

        this.axios({
          method: "POST",
          url: `${process.env.VUE_APP_BASE_URL_GENERAL}/api/general/attachments`,
          data: data,
        })
          .then((res) => {
            this.file.image = res.data.data;

            this.file.preview = URL.createObjectURL(event);
            this.$emit("input", this.file);
            this.btnLoading = false;
          })
          .catch((err) => {
            this.file.mainMedia = null;

            this.$iziToast.error({
              title: this.$t("validation.error"),
              message: err.response.data.message,
            });

            this.btnLoading = false;
          });
      }
    },

    deleteImage() {
      this.axios({
        method: "DELETE",
        url: `${process.env.VUE_APP_BASE_URL_GENERAL}/api/general/attachments/${this.file.id}`,
      })
        .then(() => {
          this.file = {
            mainMedia: null,
            preview: null,
            image: null,

            id: "",
          };
          this.$emit("imageDeleted");
          this.$swal({
            title: "تم الحذف بنجاح",
            icon: "success",
            confirmButtonColor: "#3085d6",
            confirmButtonText: "نعم",
          });
        })
        .catch((err) => {
          this.$swal({
            title: err.response.data.message,
            icon: "error",
            confirmButtonColor: "#d33",
            confirmButtonText: "اغلاق",
          });
        });
    },
    confirmDelete() {
      this.$swal({
        title: "هل أنت متأكد؟",
        text: "لن يكون بإمكانك الرجوع في العملية!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "لا",
        confirmButtonText: "احذف",
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleteImage();
        }
      });
      // End:: Sweet Alert  Modal
    },
    updateValue() {
      this.$emit("input", this.file);
    },
  },
  mounted() {
    if (this.data.modelValue) {
      this.file.preview = this.data.modelValue.media;

      this.file.id = this.data.modelValue.id;
    }
  },
};
</script>

<style></style>
